module.exports = __webpack_public_path__ + "img/91eb89b.png";